var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChromeLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 32,
    fill: "#CCCCCC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Modal/Panel Base"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 422,
    height: 1192,
    transform: "translate(-186 -57)",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 237485"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 389,
    height: 1144,
    transform: "translate(-178 -9)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 237574"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chrome",
    clipPath: "url(#clip0_11325_80)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.4976 7.9995L30.3517 7.99952C28.9478 5.56712 26.9283 3.5472 24.4961 2.14288C22.064 0.738553 19.305 -0.000674564 16.4965 -0.000478249C13.688 -0.000281199 10.9291 0.739333 8.49718 2.144C6.06522 3.54866 4.04596 5.56886 2.64241 8.00146L9.56951 19.9995L9.57567 19.9979C8.871 18.7827 8.49913 17.4033 8.49756 15.9986C8.49598 14.5939 8.86475 13.2136 9.56668 11.9969C10.2686 10.7802 11.2789 9.76998 12.4957 9.06818C13.7125 8.36638 15.0929 7.99777 16.4976 7.9995Z",
    fill: "url(#paint0_linear_11325_80)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.4292 19.9985L16.5021 31.9966C19.3106 31.997 22.0697 31.258 24.5019 29.8538C26.9342 28.4497 28.9539 26.4299 30.3579 23.9976C31.762 21.5653 32.5009 18.8062 32.5004 15.9977C32.4999 13.1893 31.76 10.4304 30.3551 7.99864L16.5009 7.99866L16.4992 8.00479C17.9039 8.00211 19.2845 8.36979 20.5018 9.07077C21.7191 9.77175 22.73 10.7812 23.4328 11.9975C24.1356 13.2138 24.5053 14.5938 24.5046 15.9985C24.504 17.4032 24.1331 18.7829 23.4292 19.9985Z",
    fill: "url(#paint1_linear_11325_80)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.57323 20.002L2.64617 8.00391C1.24158 10.4359 0.502058 13.1948 0.501953 16.0033C0.501848 18.8118 1.24117 21.5708 2.64557 24.0029C4.04997 26.435 6.06995 28.4545 8.50241 29.8583C10.9349 31.2621 13.694 32.0007 16.5025 31.9999L23.4296 20.0018L23.4251 19.9973C22.7251 21.2151 21.7164 22.2269 20.5007 22.9306C19.285 23.6343 17.9052 24.0051 16.5005 24.0056C15.0958 24.0061 13.7158 23.6362 12.4996 22.9333C11.2835 22.2304 10.2741 21.2193 9.57323 20.002Z",
    fill: "url(#paint2_linear_11325_80)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.5 24C20.9183 24 24.5 20.4183 24.5 16C24.5 11.5817 20.9183 8 16.5 8C12.0817 8 8.5 11.5817 8.5 16C8.5 20.4183 12.0817 24 16.5 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.4993 22.3327C19.9972 22.3327 22.8327 19.4972 22.8327 15.9993C22.8327 12.5015 19.9972 9.66602 16.4993 9.66602C13.0015 9.66602 10.166 12.5015 10.166 15.9993C10.166 19.4972 13.0015 22.3327 16.4993 22.3327Z",
    fill: "#1A73E8"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11325_80",
    x1: 28.6234,
    y1: 7.00112,
    x2: 14.7687,
    y2: 30.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D93025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA4335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11325_80",
    x1: 31.2634,
    y1: 9.99966,
    x2: 3.55407,
    y2: 9.99963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBC04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11325_80",
    x1: 18.2329,
    y1: 31.0009,
    x2: 4.37823,
    y2: 7.00391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E8E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34A853"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11325_80"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChromeLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ChromeLogo.476897a543c04076d13af8b7e3075b7e.svg";